import styles from '../styles/howToStart.module.scss';
import join_table from '../assets/join_table.png';
import how_to_start from '../assets/how_to_start.png';

function HowToStartPlaying() {
  return (
    <div className={styles.start}>
      <h3>"How to Join a table or game"</h3>
      <img src={join_table} alt="Join table" className={styles.image}/>
      <p>
        To join a game, you will have to select (click and highlight) one of the available tables (from the
        top portion of the window) and press the 'Join Table' button.
      </p>

      <p>
        In the picture above, the highlighted table (#1) already has two players on it. But there's one table
        (#8) with just one player (bsdaddy) who is waiting for an opponent. To join bsdaddy's table, you need
        to highlight it (select it) first.
      </p>
      <p>
        If the highlighted table already has two players, you can only select a 'Watch Table' button [if it is
        a $ game - watching will be disallowed]. You can also join a game just by double-clicking on a table
        where one player is waiting for an opponent. There are also tables (marked with 'X') - they are
        invitation-only & cannot be joined unless the owner of the table send you a personal invitation.
      </p>
      <p>
        You can play for free. If there are monetary units -- $Tickets listed for tables, then the players at
        these tables are 'spicing up' their games to make them more competitive and more entertaining. They
        are not just playing just a social game -- they are playing these games of skill competitively for
        $prizes. Players who have cash-equivalent $Tickets in their accounts are shown in blue with a dollar
        sign in front of their screen names. If you buy Tickets, they will be deposited into your account and
        you will be able to play for $prizes as well!
      </p>
      <p>
        Instead of Joining someone else's table, you can use a Create Table button and create your own table.
        You will be in control of the table -- you will be able to select all table options, choose time
        control options, etc. After the table has been created, you will have either to wait for somebody to
        join your table or you might want to invite others to join your table.
      </p>
        <h3>How to start a game</h3>
      <p>
        If you created the table (as opposed to joined someone else's table), you will have to wait for an
        opponent to join your table. Once two players are 'sitting' at the table, press the 'Start' button -
        as shown in the picture above.
      </p>
      <img src={how_to_start} alt="How to start" className={styles.image}/>
    </div>
  );
}

export default HowToStartPlaying;
